import { gql } from "@apollo/client";
import { EventFragment } from "@/fragments/Event";
import { PageDataFragment } from "@/fragments/PageData";

export const AdditionalContentFragment = gql`
  ${EventFragment}
  ${PageDataFragment}
  fragment AdditionalContent on Inductee {
    inducteeData {
      overrideDefaultFeature
      feature {
        headline
        items {
          body
          ctaLabel
          headline
          linkType
          sectionId
          pillLabel
          image {
            ...ACFMedia
          }
          externalLink
          page {
            node {
              databaseId
              __typename
              uri
              ... on Event {
                ...EventFragment
              }
            }
          }
        }
      }
      includeShopCarousel
      inducteeShopCarousel {
        headline
        type
        shopifyCollection
        shopifyTag
        searchValue
        cta {
          linkType
          label
          externalLink
          page {
            node {
              uri
            }
          }
        }
      }
      gridInductees {
        headline
        cta {
          linkType
          label
          externalLink
          page {
            node {
              uri
            }
          }
        }
        featuredInductees(first: 12) {
          nodes {
            ... on Inductee {
              title
              uri
              ...PageData
              inducteeData {
                inducteeClass {
                  slug
                }
              }
            }
          }
        }
      }
    }
  }
`;
